// bleRegistry.ts
const bleRegistry = new Map<
    string,
    { device: BluetoothDevice; characteristic: BluetoothRemoteGATTCharacteristic }
>();

export const addBleDevice = (
    id: string,
    device: BluetoothDevice,
    characteristic: BluetoothRemoteGATTCharacteristic
) => {
    bleRegistry.set(id, { device, characteristic });
};

export const getBleDevice = (id: string) => bleRegistry.get(id);

export const removeBleDevice = (id: string) => {
    const entry = bleRegistry.get(id);
    bleRegistry.delete(id);
    return entry; // 🔹 ahora sí retorna { device, characteristic } | undefined
};
